<app-flash-alert
  [isDismissible]="alertState().isDismissible"
  [title]="alertState().title"
  [message]="alertState().message"
  [type]="alertState().type"/>

<router-outlet></router-outlet>
